import axios, { AxiosResponse } from 'axios';

import { EDruhCp } from 'enums/isin/udaje/druhCp';

import { IIsinRegistraceSoubor } from './isinUpload';

export interface IIdentifikaceEmitenta {
    idmb?: string;
    stat?: string;
    nazev?: string;
    lei?: string;
    emitentje?: string;
    podobacp?: string;
    evidencecp?: string;
    pravniforma?: string;
    kodpravniformy?: string;
    adma?: string;
    mema?: string;
    pscm?: string;
    kost?: string;
    mena?: string;
    kapital?: number;
    splaceno?: number;
    madic?: true;
    dic?: string;
    bankspojeni?: string;
    zemesidla?: string;
    email?: string;
    emailkont?: string;
    telefon?: string;
    emitentazas?: string;
    druhcp?: EDruhCp;
    redirect?: string;
    idzadosti?: number;
    datumzmeny?: string;
    idZadosti?: number;
    stav?: string;
    popis?: string;
    nace?: string;
    nacepopis?: string;
    // registrace polozky
    ompr?: boolean;
    cval?: string;
    cfi?: string;
    fisn?: string;
    jmeno?: string;
    prijmeni?: string;
    prilohy?: IIsinRegistraceSoubor[];
}

const identifikaceEmitenta = (
    method: 'POST' | 'get' | 'PUT',
    idZadosti: number | string,
    data?: IIdentifikaceEmitenta,
    typZadosti?: 'Zruseni' | 'Zmena' | 'Registration'
) => {
    return axios({
        method: method,
        url:
            typZadosti === 'Registration'
                ? `RegistraceISIN/${idZadosti}`
                : `Zadosto${typZadosti ? typZadosti : ''}ISIN/${idZadosti}`,
        data: data
    }).then((resp: AxiosResponse<IIdentifikaceEmitenta>) => resp.data);
};

export default identifikaceEmitenta;
